

















































































import Vue from 'vue'
import TextMessage from './messages/TextMessage.vue'
import FileMessage from './messages/FileMessage.vue'
import EmojiMessage from './messages/EmojiMessage.vue'
import TweetMessage from './messages/TweetMessage.vue'
import TypingMessage from './messages/TypingMessage.vue'
import { Button } from 'element-ui'

export default Vue.extend({
  props: {
    message: {
      type: Object,
      required: true
    },
    colors: {
      type: Object,
      required: true
    },
    messageStyling: {
      type: Boolean,
      required: true
    },
    user: {
      type: Object,
      required: true
    },
    widgetwidth: {
      type: Number,
      required: true
    },
    widgetheight: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    messageStyle: {},
    chatIcon: require('@/assets/dummyuser.jpg')
  }),
  mounted (): void {
    this.calculateMessageStyle()
  },
  methods: {
    toTime (timestamp: number): string {
      const milliseconds = this.now - timestamp
      let minutes = Math.round(milliseconds / 1000 / 60)
      if (minutes <= 0) {
        return 'just now'
      } else if (minutes === 1) {
        return '1 min ago'
      }
      const hours = Math.floor(minutes / 60)
      if (hours === 0) {
        return `${minutes} min ago`
      }
      minutes -= hours * 60
      return `${hours} h ${minutes} min ago`
    },
    calculateMessageStyle (): void {
      const style = {} as Partial<CSSStyleDeclaration>
      if (this.user && this.user.colors && this.user.colors.bg) {
        style.backgroundColor = this.user.colors.bg
      }
      if (this.user && this.user.colors && this.user.colors.text) {
        style.color = this.user.colors.text
      }
      style.borderRadius = '10px'
      style.minWidth = '60%'
      style.wordBreak = 'break-word'
      this.messageStyle = style
    }
  },
  watch: {
    user: {
      handler (): void {
        this.calculateMessageStyle()
      },
      deep: true
    }
  },
  computed: {
    now (): number {
      return this.$store.state.clock.minute * 60000
    },
    fontsize (): number {
      let fontsize = this.widgetwidth / 30
      if (fontsize > 18) {
        fontsize = 18
      }
      return fontsize
    },
    authorName (): string {
      return this.user && this.user.name
    },
    chatImageUrl (): string {
      return (this.user && this.user.imageUrl) || this.chatIcon
    },
    timestyle (): Partial<CSSStyleDeclaration> {
      if (this.message.author === 'me') {
        return {
          left: '4%',
          textAlign: 'left'
        }
      }
      return {
        right: '4%',
        textAlign: 'right'
      }
    }
  },
  components: {
    TextMessage,
    FileMessage,
    EmojiMessage,
    TweetMessage,
    TypingMessage,
    'el-button': Button
  },
})
